
const GreenGlobeClub = () => {
  return (
    <div className="main-body">
      <div>
        <section className="in-banner">
          <div className="inheading">
            <h1>Green Globe Club</h1>
          </div>
        </section>
        <div className="breed-crum-div-wrap">
          <div className="breed-crum-div">
            <ol className="breadcrumb">
              <li>
                <a href="/" className="external none">
                  Home
                </a>
                <span> | </span>
              </li>
              <li>
                <a href="/events" className="external none">
                  EVENTS
                </a>
                <span> | </span>
              </li>
              <li>
                <a href="/events/green-globe-club" className="external none">
                  GREEN-GLOBE-CLUB
                </a>
              </li>
            </ol>
          </div>
        </div>
        <div className="contentarea">
          <div className="sub-contentarea">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-md-4">
                <img
                  decoding="async"
                  src="https://campus.acetians.in/custom/images/green-globe.png"
                  alt
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col-md-8" style={{ margin: "auto" }}>
                <div>
                  <div className>
                    <p style={{}}>
                      Green Globe Club is an integral part of our college and
                      all the students who join the college become a member of
                      this club by default.
                    </p>
                    <h3 style={{}}>Its Purpose or Objectives</h3>
                    <p style={{}}>
                      Green Globe Club play an important role in creating
                      environmental <br /> awareness in the college and
                      motivates to be conscious about the environment where we
                      can live and breathe freely. Few of its main objectives
                      are:
                    </p>
                    <ul style={{}}>
                      <li style={{}}>Encourage Organic method of farming</li>
                      <li style={{}}>Organize tree plantation programmes</li>
                      <li style={{}}>Promote conservation of water</li>
                      <li style={{}}>
                        Switching to renewable energy sources for our energy
                        need
                      </li>
                      <li style={{}}>
                        Promote minimum waste generation, source separation of
                        waste and its proper disposal
                      </li>
                      <li style={{}}>
                        Spreading awareness for conservation of the
                        biodiversity.
                      </li>
                    </ul>
                    <h2 style={{}}>Its Volunteers-</h2>
                    <p style={{}}>
                      All the students and alumni of the college.
                    </p>
                    <h2 style={{}}>Activities-</h2>
                    <ul style={{}}>
                      <li style={{}}>
                        Tree Plantation Drive: They have already planted
                        hundreds of trees in college premises and around the
                        college.
                      </li>
                    </ul>
                    <p style={{}} />
                    <ul>
                      <li>
                        Tagging Of Plants: They are effectively tagging plants
                        so that students get the idea of its name and
                        identification
                      </li>
                    </ul>
                    <p style={{}} />
                    <ul style={{}}>
                      <li style={{}}>
                        Renewable Energy: Installed solar panels for generating
                        electricity.
                      </li>
                    </ul>
                    <p style={{}} />
                    <ul style={{}}>
                      <li style={{}}>
                        Water Harvesting System: The college has three units of
                        water harvesting system for water conservation.
                      </li>
                    </ul>
                    <p style={{}} />
                    <ul style={{}}>
                      <li style={{}}>
                        Built Bird Houses, Bird Bath &amp; Bird Feeder: They
                        have installed several bird houses to provide a safe
                        shelter for birds to build their nest, a protective
                        cover from the weather and predators.
                      </li>
                    </ul>
                    <p style={{}} />
                    <ul style={{}}>
                      <li style={{}}>
                        Butterfly Garden: They are developing a beautiful
                        butterfly garden to conserve butterflies and help
                        perpetuate native plant species
                      </li>
                    </ul>
                    <p style={{}} />
                    <ul style={{}}>
                      <li style={{}}>
                        Honeybee Farming Initiative: Beekeeping is a low
                        investment &amp; skill industry having the potential to
                        offer direct employment to lakhs of unemployed youth
                        &amp; farmers
                      </li>
                    </ul>
                    <p style={{}} />
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row col-md-12  d-flex">
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe1.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe1.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe2.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe2.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe3.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe3.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe4.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe4.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe5.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe5.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe6.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe6.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe7.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe7.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/greenglobe8.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/greenglobe8.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GreenGlobeClub
